module.exports = __webpack_public_path__ + "img/empty-state.05c6aa5d.svg";